import { render } from "./component-egrul-status-name.vue?vue&type=template&id=9f553788"
import script from "./component-egrul-status-name.vue?vue&type=script&setup=true&lang=js"
export * from "./component-egrul-status-name.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/counteragents/counteragent-version-card/components/component-egrul-status-name.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9f553788"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9f553788', __exports__)) {
    api.reload('9f553788', __exports__)
  }
  
  module.hot.accept("./component-egrul-status-name.vue?vue&type=template&id=9f553788", () => {
    api.rerender('9f553788', render)
  })

}


export default __exports__